import { createSlice } from "@reduxjs/toolkit";

const cartslice = createSlice({
  initialState: [],
  name: "cartslice",
  reducers: {
    addToCart: (state, action) => {
      // state.push(action.payload);
      const findeproduct = state.find(
        (product) => product.id === action.payload.id
      );
      if (findeproduct) {
        findeproduct.quantity += 1;
      } else {
        const productclone = { ...action.payload, quantity: 1 };
        state.push(productclone);
      }
    },
    deleteItem: (state, action) => {
      return state.filter((product) => product.id !== action.payload.id);
    },
    clearCart: () => {
      return [];
    },
  },
});

export const { addToCart, deleteItem, clearCart } = cartslice.actions;
export default cartslice.reducer;
